import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "margin-right"
    }}>{`margin-right`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{`  UXP v2.0`}</p>
    <p>{`Specifies the right margin for an element.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en/docs/Web/CSS/margin-right"
      }}>{`https://developer.mozilla.org/en/docs/Web/CSS/margin-right`}</a></p>
    <p><strong parentName="p">{`Example`}</strong>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`.someElement {
    margin-right: 1em;
}
`}</code></pre>
    <h2 {...{
      "id": "quirks-and-exceptions"
    }}>{`Quirks and Exceptions`}</h2>
    <ul>
      <li parentName="ul">{`Margins do not collapse in UXP.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      